export const DEFAULT_RENDER_STATES = {
  shouldRenderUserBubble: false,
  shouldRenderAgentResponse: false,
  shouldRenderSkeleton: false,
  shouldRenderError: false,
};
